import { useMutation, useQueryClient } from "@tanstack/react-query";

import VoucherCartItemsQueries from "./queries";
import { deleteVoucherCartItem, saveVoucherCartItem } from "./requests";

export const useSaveVoucherCartItem = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: saveVoucherCartItem,
    onSuccess: (data, variables) => {
      queryClient.setQueryData(
        VoucherCartItemsQueries.cartItems(variables.voucherCartUuid).queryKey,
        (oldData) => {
          if (!oldData) return [data];
          if (variables.uuid) {
            return oldData.map((item) =>
              item.uuid === variables.uuid ? data : item,
            );
          }
          return [...oldData, data];
        },
      );
    },
  });
};

export const useDeleteVoucherCartItem = (voucherCartUuid: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteVoucherCartItem,
    onSuccess: (_, uuid) => {
      queryClient.setQueryData(
        VoucherCartItemsQueries.cartItems(voucherCartUuid).queryKey,
        (oldData) => {
          if (!oldData) return [];
          return oldData.filter((item) => item.uuid !== uuid);
        },
      );
    },
  });
};
